module.exports = __webpack_public_path__ + "static/img/ri-home-line.4fa3bdea.svg";